/*

 +-++-++-++-++-++-++-++-++-++-++-++-++-+
 |Q||u||a||r||t||e||r||M||a||s||t||e||r|
 +-++-++-++-++-++-++-++-++-++-++-++-++-+

 Interceptor for data

 */

import { get } from 'lodash';
import { BUSINESS } from '../constants/QMTypes';

export const performDataAction = (action, actionData) => {
  if (!action) return;

  const actions = action.split(':');

  switch (actions[0]) {
    case 'SET_ME': {
      // store.dispatch(setMe(actionData.data));
      break;
    }
    case BUSINESS: {
      // store.dispatch(stateUpdate({ id: actions[1], type: BUSINESS }));
      break;
    }
    case 'ALL_CONNECTION':
    case 'ALL_CONNECTIONS': {
      // getAllConnections();
      break;
    }
    default:
      break;
  }
};

export const performDataKeys = keys => {
  if (!keys || !keys.length) return;

  keys.forEach(key => {
    // store.dispatch(keyUpdate({ key }));
  });
};

export const dataAction = stateData => {
  performDataAction(stateData.data_action, stateData);
  performDataAction(stateData.data_action_secondary, stateData);
  performDataKeys(stateData.data_refresh_keys, stateData);
};

export const dataInterceptor = response => {
  const stateData =
    get(response, 'data.state_data') ||
    get(response, 'data.data.state_data', undefined);
  // if (stateData) dataAction(stateData);
};
